import { useMemo } from 'react';

import useDataFetcher from '~/components/useDataFetcher';
import type { ClaimFieldCatalogResponse } from '~/server_shared/openapi/data-contracts';

import { getCatalogUrl } from '../apiService';

export type ClaimFieldCatalogFetch = {
  data: ClaimFieldCatalogResponse | undefined;
  isLoading: boolean;
  isError: boolean;
};

/** The fields a scope's configuration can show and add, read only while `shouldFetch`. */
const useClaimFieldCatalog = (
  organizationId: number,
  lob: string | null,
  subOrganizationId: number | null,
  shouldFetch: boolean
): ClaimFieldCatalogFetch => {
  // Neither param for the Default; the LOB alone for a LOB's own configuration, which only an organization
  // without sub-organizations has.
  const config = useMemo(
    () => ({
      params: {
        ...(lob === null ? {} : { lob }),
        ...(subOrganizationId === null ? {} : { sub_org_id: subOrganizationId }),
      },
    }),
    [lob, subOrganizationId]
  );
  const { data, isLoading, isError } = useDataFetcher<ClaimFieldCatalogResponse>(
    getCatalogUrl(organizationId),
    config,
    shouldFetch
  );
  return { data, isLoading, isError };
};

export default useClaimFieldCatalog;
